

























import { Component, Vue } from 'vue-property-decorator';

@Component({
    components: {
    },
})
export default class Notifications extends Vue {
    private notifications = [
        {
            title: "Prueba"
        },
        {
            title: "Prueba"
        },
        {
            title: "Prueba"
        },
        {
            title: "Prueba"
        }
    ];
    private mounted() {
    }
}
